export default __webpack_public_path__ + "static/media/comment-emote-heart.754aa41d.svg";